export default __webpack_public_path__ + "static/media/dictionary-icon.e355eb74.png";